<template>
  <v-dialog v-model="dialog" v-bind="$attrs" v-on="$listeners">
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" :open="showDialog" v-bind="scope" />
    </template>
    <DialogContainer>
      <DialogHeader v-if="title" :titleIcon="titleIcon" @close="cancel">
        {{ title }}
      </DialogHeader>
      <DialogBody class="tw-px-5 tw-pt-7 tw-pb-5">
        {{ bodyText }}
      </DialogBody>
      <DialogFooter>
        <DialogActions>
          <Button tabindex="0" theme="tertiary" @click.prevent="cancel">
            {{ cancelButtonText }}
          </Button>
          <Button
            ref="confirmButtonRef"
            :loading="loading"
            :theme="confirmButtonTheme"
            autofocus
            tabindex="0"
            @click.prevent="confirm">
            {{ confirmButtonText }}
          </Button>
        </DialogActions>
      </DialogFooter>
    </DialogContainer>
  </v-dialog>
</template>

<script>
import Button from '@/components/Buttons/Button.vue'

export default {
  name: 'GenericConfirmationDialog',
  components: { Button },
  emits: ['cancelled'],
  refs: ['confirmButtonRef'],
  props: {
    confirmButtonTheme: {
      type: String,
    },
    titleIcon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    bodyText: {
      type: String,
      required: true,
    },
    confirmButtonText: {
      type: String,
      default: 'Ok',
    },
    cancelButtonText: {
      type: String,
      default: 'Abbrechen',
    },
    confirmHandler: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    dialog(value) {
      if (!value) {
        return
      }

      this.$nextTick(() => this.$refs.confirmButtonRef.$el.focus())
    },
  },
  data() {
    return {
      loading: false,
      dialog: false,
    }
  },
  methods: {
    async confirm() {
      this.loading = true
      try {
        await this.confirmHandler()
        this.closeDialog()
      } finally {
        this.loading = false
      }
    },
    cancel() {
      this.$emit('cancelled')
      this.closeDialog()
    },
    closeDialog() {
      this.dialog = false
    },
    showDialog() {
      this.dialog = true
    },
  },
}
</script>
